import { withStateHandlers } from 'recompose'
import './addLoading.less'

export default withStateHandlers(
  { confirmLoading: false },
  { setLoading: () => value => ({ confirmLoading: value }) }
)
